import React, {FC, useMemo, useState, useEffect} from "react";
import {Section} from "@/scripts/section";
import { motion } from "framer-motion";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";

export type BaseSectionProps = {
    section: Section;
}

export const BaseSection: FC<BaseSectionProps & React.HTMLProps<HTMLDivElement>> = (props) => {
    const {section, children} = props;
    const {id, viewHook: {ref, inView}} = section;
    const [hasBeenViewed, setHasBeenViewed] = useState(false);
    
    useEffect(() => {
        if (inView && !hasBeenViewed) {
            setHasBeenViewed(true);
        }
    }, [inView, hasBeenViewed]);
    
    const reducedMotion = usePrefersReducedMotion();

    const variants = useMemo(() => ({
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                duration: reducedMotion ? 0 : 0.4,
                ease: [0.16, 1, 0.3, 1] as const
            }
        }
    }), [reducedMotion]);

    return (
        <motion.section 
            className="section-box" 
            id={id} 
            ref={ref}
            initial="hidden"
            animate={hasBeenViewed ? "visible" : "hidden"}
            variants={variants}
            data-inview={hasBeenViewed ? "true" : "false"}
        >
            {children}
        </motion.section>
    )
};